export class Alert {
  private element: HTMLElement;
  private title: HTMLElement | null;
  private message: HTMLElement | null;
  private link: HTMLAnchorElement | null;
  private emergencyAlertData: any;
  private endpoint: string | null | undefined;
  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.title = this.element.querySelector(".emergency-alert__label");
      this.message = this.element.querySelector(".emergency-alert__message");
      this.link = this.element.querySelector(".emergency-alert__link");
      this.endpoint = this.element.dataset.endpoint;
      this.getData()
        .then((data) => {
          this.emergencyAlertData = data;
          this.populateContent();
          this.setAlertHeightInCSS();
        })
        .catch((error) => {
          console.log(error);
          this.removeAlert();
        });
    }
  }

  // always get data[0] to avoid multiples
  private async getData() {
    if (
      !window.location.href.startsWith("http://localhost") &&
      !window.location.href.startsWith(
        "https://idfive-component-library.netlify.app/",
      )
    ) {
      if (this.endpoint) {
        try {
          const timestamp = new Date()
            .toISOString()
            .replace(/[-:T.]/g, "")
            .slice(0, 12);
          const response = await fetch(`${this.endpoint}?time=${timestamp}`);
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const data = await response.json();
          return data;
        } catch (error) {
          return null;
        }
      }
    } else {
      try {
        const response = await fetch("/src/data/alert.json");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }

  private removeAlert() {
    this.element.remove();
  }

  private populateContent() {
    // Validate data structure exists
    if (
      !this.emergencyAlertData ||
      !this.emergencyAlertData.results ||
      !Array.isArray(this.emergencyAlertData.results) ||
      !this.emergencyAlertData.results[0]
    ) {
      this.removeAlert();
      return;
    }

    if (this.title) {
      this.title.innerHTML = `${this.emergencyAlertData.results[0].title}`;
    }
    if (this.message) {
      this.message.innerHTML = `${this.emergencyAlertData.results[0].text}`;
    }
    if (this.link) {
      if (this.emergencyAlertData?.results?.[0]?.url?.url) {
        this.link.href = `${this.emergencyAlertData.results[0].url.url}`;
        this.link.innerHTML = `${this.emergencyAlertData.results[0].url.title}`;
      }
    }
    this.element.classList.add("emergency-alert--active");
  }

  private setAlertHeightInCSS() {
    let ticking: boolean = false;

    const alertHeight = () => {
      const alertHeight = this.element.getBoundingClientRect().height;
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize,
      );
      const alertHeightRem = (alertHeight / rootFontSize).toFixed(2);
      document.documentElement.style.setProperty(
        "--alert-height",
        `${alertHeightRem}rem`,
      );
      ticking = false;
    };

    window.addEventListener(
      "resize",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            alertHeight();
          });
          ticking = true;
        }
      },
      true,
    );
    alertHeight();
  }
}

export default function alertsInit() {
  const alerts = document.querySelectorAll(
    ".emergency-alert",
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < alerts.length; i++) {
    new Alert(alerts[i]);
  }
}
